<template>
  <AvatarComponent
    :size="size"
    :color="avatarColor.color"
    :text-color="avatarColor.text"
    :text="userInitials"
    :tooltip="showTooltip ? userName(userId) : ''"
  />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AvatarComponent from './AvatarComponent';
import { getColorForId } from '../../tools/UsersColors';
import { types as usersTypes } from '../../store/users';

export default {
  name: 'Avatar',
  components: {
    AvatarComponent,
  },
  props: {
    userId: {
      type: String,
      default: '',
    },
    size: {
      type: [Number, String],
      default: undefined,
    },
    color: {
      type: String,
      default: undefined,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      usersProfiles: usersTypes.getters.usersProfiles,
      getUserInitials: usersTypes.getters.userInitials,
      userName: usersTypes.getters.userName,
    }),
    avatarColor() {
      if (this.color) {
        return { color: this.color, text: 'white' };
      }

      if (this.userId) {
        return {
          color: getColorForId(this.userId),
          text: 'white',
        };
      }
      return { color: 'grey', text: 'white' };
    },
    userInitials() {
      return this.getUserInitials(this.userId);
    },
  },
  beforeMount() {
    if (this.userId && (!this.usersProfiles || !this.usersProfiles[this.userId])) {
      this.getUserProfile(this.userId);
    }
  },
  methods: {
    ...mapActions({
      getUserProfile: usersTypes.actions.getUserProfile,
    }),
  },
  watch: {
    userId(nextUserId) {
      if (nextUserId && (!this.usersProfiles || !this.usersProfiles[nextUserId])) {
        this.getUserProfile(nextUserId);
      }
    },
  },
};
</script>
